import { useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'
import { ConfigurationDefinitionsKeys } from '../store/Constants'
import { useConfigurationDefinitions } from './useConfigurationDefinitions'
import { useExternalLink } from './useExternalLink'

/**
 * Builds HP Support links based on the current printer and localization
 * @returns { hpSupportProductPage, hpSupportSetupAndUserGuides }
 */
export const useBuildHpSupportLink = () => {
  const { printer, localization } = useContext(ConfigContext)
  const { findConfigurationDefinitions } = useConfigurationDefinitions()
  const { findExternalLink } = useExternalLink()

  const hpSupportLocaleMap = findConfigurationDefinitions(
    ConfigurationDefinitionsKeys.hpSupportLocaleMap
  )

  const language = localization?.language?.toLowerCase()
  const countryCode = localization?.country?.toLowerCase()
  const localizationCode =
    language && countryCode ? `${language}-${countryCode}` : null

  const finalLocale = localizationCode
    ? hpSupportLocaleMap?.[localizationCode] || localizationCode
    : null

  const navigationCodesMap = {
    'product-page': '001',
    'setup-and-user-guide': '003'
  }

  const link = findExternalLink('HP_SUPPORT_SPECIFIC')

  const buildLink =
    link?.link?.href && printer?.oid && finalLocale
      ? link.link.href
          .replaceAll('[[PRODUCT_OID]]', printer.oid)
          .replaceAll('[[LANGUAGE]]', finalLocale.split('-')[0])
          .replaceAll('[[COUNTRY_CODE]]', finalLocale.split('-')[1])
      : undefined

  const hpSupportProduct = buildLink
  const hpSupportSetupAndUserGuides = buildLink?.replace(
    '001',
    navigationCodesMap['setup-and-user-guide']
  )
  const hpSupportPrinterSetup = findExternalLink('HP_SUPPORT')?.link?.href

  return {
    hpSupportProduct,
    hpSupportSetupAndUserGuides,
    hpSupportPrinterSetup
  }
}
